module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs",
    class: _vm.rootClasses,
    attrs: {
      "role": "tablist"
    }
  }, [_c('div', {
    staticClass: "tabs--panel"
  }, [_c('ul', {
    staticClass: "u-reset tabs--headers",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.items), function(item, itemIdx) {
    return _c('li', {
      staticClass: "tabs--header",
      attrs: {
        "role": "presentation"
      }
    }, [_c('button', {
      staticClass: "btn btn__small",
      class: _vm.buttonClasses,
      attrs: {
        "data-active": _vm.state.idx === itemIdx,
        "role": 'tab',
        "id": _vm.ariaUid('header', itemIdx),
        "aria-controls": _vm.ariaUid('panel', itemIdx),
        "aria-selected": _vm.state.idx === itemIdx
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestChange(itemIdx)
        }
      }
    }, [_vm._t("head", null, {
      item: item
    })], 2)])
  }))]), _vm._v(" "), _c('transition-group', {
    staticClass: "tabs--body",
    attrs: {
      "tag": "div",
      "name": "trs-tabs-change"
    }
  }, _vm._l((_vm.items), function(item, itemIdx) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.state.idx === itemIdx),
        expression: "state.idx === itemIdx"
      }],
      key: itemIdx,
      staticClass: "tabs--body-content",
      attrs: {
        "role": "tabpanel",
        "id": _vm.ariaUid('panel', itemIdx),
        "aria-labelledby": _vm.ariaUid('header', itemIdx)
      }
    }, [_vm._t("body", null, {
      item: item
    })], 2)
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d7230f4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7230f4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/ui/tabs/index.vue
// module id = 586
// module chunks = 7